'use client';

import { useEffect } from 'react';

/**
 * 로그인 화면은 항상 다크로 보이게 하되, 진입 전 사용자가 선택한 테마(예: 라이트)는
 * 페이지를 떠날 때 복원합니다. 테마 토글은 이 라우트에서 숨깁니다.
 */
export default function LoginLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const root = document.documentElement;
    const hadLight = root.classList.contains('light');
    const prevScheme = root.style.colorScheme;
    root.classList.remove('light');
    root.style.colorScheme = 'dark';

    const meta = document.querySelector('meta[name="theme-color"]');
    const prevThemeColor = meta?.getAttribute('content') ?? null;
    meta?.setAttribute('content', '#0A0A0B');

    return () => {
      if (hadLight) root.classList.add('light');
      else root.classList.remove('light');
      root.style.colorScheme = prevScheme || (hadLight ? 'light' : 'dark');
      if (meta) {
        if (prevThemeColor !== null) meta.setAttribute('content', prevThemeColor);
      }
    };
  }, []);

  return children;
}
